import { cr, ck, interact, URLS } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import { settingData } from "../common/settingData";
import service from "../service/form";
import { customFormId, isIframe } from "../common/sbase";
import URL from "../assets/conf/setting.json";
import { isInWechatAuth, initJsSdk, agentType } from "/stempcore/src/sbase";
import { forkJoin } from "rxjs";
export default {
  data() {
    return {
      formData: [],
      formInfo: {},
      isSubmitting: false,
      whereform: "other",
      member: {},
      mettInfo: {}, //线上会会议详情
      serverTime: "", // 服务器时间
      webinarState: "", //线上会状态
      preview: sbaseData.preview,
      linkEnd: false,
      isJump: false,
      d: window.$sk.template.get().common,
      tenantId: "",
      rulesInfo: [],
      rulesJump: 0,
      isTrackClosed: false, // 推广链接是否已关闭
      isTrackClosedMessage: false,
    };
  },

  created() {
    sbaseData.init();
    if (!sbaseData.isSetting) {
      window.$sk.loading.show();
    } else {
      this.whereform = "webinar";
    }
    window.$sk.template.module(this);
  },
  computed: {
    changeData() {
      const { user, linkEnd } = this;
      return {
        user,
        linkEnd,
      };
    },
  },

  watch: {
    changeData: {
      handler: function (n) {
        if (n.linkEnd && n.user.status) {
          console.log("都监听完了", this.isJump);
          if (!this.isJump) {
            this.platformVSurl();
            this.afterGetData();
          }
        }
      },
    },
  },
  mounted() {
    //window.$model.user.init(this.customformGet);
  },

  methods: {
    skUserInit() {
      console.log("获取用户本地信息");
    },
    checkTrackStatus() {
      var checkParams = {
        tenantId: this.tenantId,
      };
      if (sbaseData.trackId) {
        checkParams.track_id = sbaseData.trackId;
      }
      if (sbaseData.tc) {
        checkParams.tc = sbaseData.tc;
        checkParams.moduleId = window.$sk.template.get().common.moduleId;
        checkParams.moduleObjectId = sbaseData.webinarId || sbaseData.seminarId;
      }
      service.checkTrackStatus(checkParams).subscribe((data) => {
        if (data.result == 0) {
          if (data.content.status == 0) {
            this.isTrackClosed = true;
          }
        } else {
          console.warn("检查推广链接状态失败:", data.desc);
          this.customformGet();
        }
      });
    },
    showTrackClosedMessage() {
      window.$sk.loading.hide();
      window.$sk.alert("报名已截止！", {
        okValue: "确定",
        ok: () => {
          if (sbaseData.returnUrl) {
            window.$sk.goto(sbaseData.returnUrl);
          }
        },
      });
    },
    skUserEnd() {
      const info = window.$sk.template.get();
      console.log("获取用户信息结束", info);
      this.schemaId = info.common.schemaId;
      this.instanceId = info.common.instanceId;
      this.tenantId = info.common.tenantId;
      this.user = info.user;
      if (!sbaseData.isSetting) {
        if (sbaseData.trackId || sbaseData.tc) {
          this.checkTrackStatus();
        }
        this.customformGet();
      } else {
        this.formInfo = settingData;
        this.formData = settingData.items;
        this.initConfig();
      }
    },
    customformGet() {
      forkJoin({
        formData: service.getCustomform({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
          linkId: sbaseData.linkId,
          globalUserId: this.user.globalUserId,
        }),
        rules: service.getCustomFormRules({
          customFormId: sbaseData.customFormId,
          tenantId: this.tenantId,
        }),
      }).subscribe((data) => {
        if (data.rules.result == 0) {
          this.rulesInfo = data.rules.content.items;
        }
        if (data.formData.result == 0) {
          this.formInfo = data.formData.content;
          this.member =
            ck.cookie("smarketMember_" + this.formInfo.schemaId) || {};
          this.initConfig();
          this.setTitle(this.formInfo);
          this.init();
          this.handleList(data.formData.content);
          this.handleRules();
        } else {
          window.$sk.alert(data.formData.desc);
        }
      });
    },
    init() {
      if (
        !this.isTrackClosed &&
        (!sbaseData.preview || this.formInfo.attendWay == 3)
      ) {
        window.$sk.template.update({
          type: "link",
          data: {
            identity: this.formInfo.attendWay,
            weChatId:
              isInWechatAuth(this.tenantId) && !isIframe()
                ? this.formInfo.attachWXAccount || sbaseData.weChatId
                : "",
            weChatIdForSubscribe:
              this.formInfo.attachWXAccount || sbaseData.weChatId,
            skObjectType: "customForm",
            skObjectId: sbaseData.customFormId,
            meetingInstanceId:
              this.formInfo.attendWay == 4
                ? this.formInfo.meetingInstanceId
                : this.instanceId,
            meetingType: this.formInfo.moduleType || this.formInfo.meetingType, // 兼容线上会||线下会
            skIsNotLink: 0,
            memberFormId: this.formInfo.regFormId,
            enableWxFollow: this.formInfo.enableWxFollow,
          },
        });
      } else {
        service
          .checkRegistration({
            customFormId: sbaseData.customFormId,
            tenantId: this.tenantId,
            instanceId:
              this.formInfo.attendWay == 4
                ? this.formInfo.meetingInstanceId
                : this.formInfo.instanceId,
            session: this.member.session,
            sess: this.member.session,
            openId: this.user.openId,
          })
          .subscribe((data) => {
            if (data.result == 0) {
              this.skUserChange({
                status: data.content,
                formData: data.content.formData,
              });
              this.linkEnd = true;
            }
          });
      }
    },
    handleRules() {
      if (this.$refs.formRef) {
        this.$refs.formRef.initData();
      }
    },
    dicValueConvert(m) {
      if (!m.listOptionType) {
        return "";
      }
      if (m.listOptionType == "CUSTOM") {
        return m.value.toString();
      }
      if (m.listOptionType == "DICT") {
        const targetField = this.formData.find(
          (a) => a.fieldName == m.fieldName
        );
        if (!targetField) {
          return "";
        }
        return this.getDictValue(targetField.dictInfo, m.value);
      }
      return "";
    },
    getDictValue(dictInfo, values) {
      if (!values || !values.length) {
        return "";
      }
      const firstLevel = dictInfo.find((d) => d.name == values[0]);
      if (!firstLevel) {
        return "";
      }
      if (values.length == 1) {
        return firstLevel.paramId;
      }
      let currentLevel = firstLevel;
      let currentChildren = [];
      for (let i = 1; i < values.length; i++) {
        for (let key in currentLevel.child) {
          currentChildren = currentLevel.child[key];
          break;
        }
        const matchedItem = currentChildren.find(
          (item) => item.name == values[i]
        );
        if (!matchedItem) {
          return "";
        }
        if (i == values.length - 1) {
          return matchedItem.paramId;
        }
        currentLevel = matchedItem;
      }
      return "";
    },
    handleList(info) {
      const res = info?.items || [];
      const needHideFields = [];
      if (this.rulesInfo.length > 0) {
        this.rulesInfo.forEach((r) => {
          r.rules.forEach((item) => {
            if (item.rulesJump == 3) {
              needHideFields.push(item.rulesGoto);
            }
          });
        });
      }
      cr.each(res, (m, index) => {
        m.required = Number(m.required);
        if (this.rulesInfo.length > 0) {
          this.applyRulesToField(m, index, needHideFields);
        } else {
          m.isShow = true;
        }
      });
      return res;
    },
    applyRulesToField(field, index, needHideFields) {
      const ruleModel = this.rulesInfo.find(
        (r) => r.rulesCode == field.fieldName
      );
      const shouldHide = needHideFields.some((r) => field.fieldName == r);
      field.sortBy = index;
      if (
        ruleModel &&
        [1, 2, 3].includes(field.fieldLevel) &&
        Array.isArray(field.value) &&
        field.value.length > 0
      ) {
        field.ruleValue = this.dicValueConvert(field);
      }
      if (ruleModel) {
        field.rulesInfo = {
          rulesType: ruleModel.rulesType,
          rules: ruleModel.rules,
        };
      }
      field.isShow = !shouldHide;
      field.isOldShow = field.isShow;
    },
    skUserChange(data) {
      console.log("用户信息发生改变", data, this.user);
      if (data) {
        this.user.status = data.status;
        this.user.formData = data.formData;
      }
    },
    skLinkEnd(e) {
      console.log("跳转逻辑判断完毕", e);
      if (
        this.formInfo.attachWXAccount &&
        interact.isWeChat &&
        !this.user.tokenInfo &&
        isInWechatAuth(this.tenantId) &&
        !isIframe()
      ) {
        window.$sk.template.update({
          type: "auth",
          data: {
            weChatId: this.formInfo.attachWXAccount,
            scope: "snsapi_userinfo",
          },
        });
      } else {
        this.linkEnd = true;
        this.isJump = e.isJump;
      }
    },
    skAuthEnd(e) {
      this.user.tokenInfo = e.tokenInfo;
      this.linkEnd = true;
      this.isJump = e.isJump;
    },
    platformVSurl() {
      const isMobile = interact.isMobile ? "wap" : "pc";
      const linkId = sbaseData.linkId || "";
      const shortUrls = this.formInfo.shortUrls;
      const shortUrl = this.formInfo.shortUrl;
      let longUrl, jumpUrl;
      if (window == parent && this.platform != isMobile) {
        //20190507 工单 在iframe中的预览bug
        if (sbaseData.markCode) {
          //裂变
          ///走了静态化以后 linKId不通链接不同
          if (linkId) {
            if (shortUrls && shortUrls[linkId]) {
              longUrl = shortUrls[linkId][isMobile].longUrl;
            } else {
              longUrl = shortUrl[isMobile].longUrl;
            }
          } else {
            longUrl = shortUrl[isMobile].longUrl;
          }
          let returnUrl =
            URLS.getURL("return_url") || URLS.getHash("return_url");
          if (returnUrl) {
            let idx = longUrl.indexOf("return_url="),
              return_url = longUrl.substring(idx + 11);
            longUrl = longUrl.replace(return_url, returnUrl);
          }
          window.$sk.goto(
            longUrl +
              "&markCode=" +
              sbaseData.markCode +
              "&markType=" +
              sbaseData.markType
          );
        } else {
          if (linkId) {
            if (shortUrls && shortUrls[linkId]) {
              jumpUrl = this.updateUrl(shortUrls[linkId][isMobile].longUrl);
            } else {
              jumpUrl = this.updateUrl(shortUrl[isMobile].longUrl);
            }
          } else {
            jumpUrl = this.updateUrl(shortUrl[isMobile].longUrl);
          }
          window.$sk.goto(jumpUrl);
        }
      }
    },
    updateUrl(url) {
      let index = url.indexOf("return_url="),
        urlStart,
        urlEnd,
        jumpUrl;
      if (index > 0) {
        urlEnd = decodeURIComponent(url.substring(index + 11, url.length));
      } else {
        urlEnd = url;
      }
      if (sbaseData.tc) {
        urlEnd = urlEnd + "&tc=" + sbaseData.tc;
      }
      if (sbaseData.sourceKey) {
        urlEnd = urlEnd + "&sourceKey=" + sbaseData.sourceKey;
      }
      if (sbaseData.returnUrl) {
        urlEnd =
          urlEnd +
          "&returnUrl=" +
          encodeURIComponent(window.btoa(sbaseData.returnUrl));
      }
      if (index > 0) {
        urlStart = url.substring(0, index);
        jumpUrl = urlStart + "return_url=" + encodeURIComponent(urlEnd);
      } else {
        jumpUrl = urlEnd;
      }

      return jumpUrl;
    },

    afterGetData() {
      console.log("this.user====", this.user);
      console.log("我要开始自己的逻辑了", this.user);
      if (
        !sbaseData.preview &&
        this.formInfo.isReSubmit == "0" &&
        this.user.status.signupStatus == "notAllow"
      ) {
        this.formData = cr.extend([], this.formInfo.items); //获取数据
        // 处理回填
        if (this.user.formData && this.user.formData.length) {
          cr.each(this.user.formData, (d) => {
            cr.each(this.formData, (m) => {
              if (m.fieldName == d.fieldName) {
                m.value = d.value;
              }
              if (m.fieldName == "mobile" && m.isCallingCodeOpen == 1) {
                m.callingCodeLookupCountry = d.callingCode;
                m.callingCodeLookupPhone = d.areaCode;
              }
            });
          });
        }
        this.asyncError();
        this.jumpLink();
      } else {
        // 互动记录
        this.interactiveView();
        service
          .lookup({
            customFormId: sbaseData.customFormId,
            tenantId: this.tenantId,
            instanceId:
              this.formInfo.attendWay == 4
                ? this.formInfo.meetingInstanceId
                : this.formInfo.instanceId,
            session: this.member.session,
            sess: this.member.session,
            openId: this.user.openId,
          })
          .subscribe(
            (data) => {
              if (data.result == 0) {
                // 处理回填
                if (data.content) {
                  cr.each(data.content, (d) => {
                    cr.each(this.formInfo.items, (m) => {
                      if (m.fieldName == d.key) {
                        m.value = d.value;
                        if (
                          m.fieldName == "mobile" &&
                          m.isCallingCodeOpen == 1
                        ) {
                          m.callingCodeLookupCountry = d.callingCode;
                          m.callingCodeLookupPhone = d.areaCode;
                        }
                      }
                    });
                  });
                }
                this.formData = cr.extend([], this.formInfo.items); //获取数据
                this.handleList(this.formInfo);
                this.handleRules();
                // 处理回填
                if (this.user.formData && this.user.formData.length) {
                  cr.each(this.user.formData, (d) => {
                    cr.each(this.formData, (m) => {
                      if (m.fieldName == d.fieldName) {
                        m.value = d.value;
                        if (
                          m.fieldName == "mobile" &&
                          m.isCallingCodeOpen == 1
                        ) {
                          m.callingCodeLookupCountry = d.callingCode;
                          m.callingCodeLookupPhone = d.areaCode;
                        }
                      }
                    });
                  });
                }
                // 检查表单状态
                this.statusToView();

                this.commonWebinar();
              } else {
                this.formData = cr.extend([], this.formInfo.items); //获取数据
                window.$sk.alert(data.desc);
              }

              this.asyncError();
            },
            () => {}
          );
      }
    },
    asyncError() {
      // 校验
      this.$nextTick(() => {
        cr.each(this.formData, (m) => {
          if (
            (this.formInfo.moduleType == 2 || this.formInfo.moduleType == 3) &&
            m.isLogin == 1 &&
            m.result
          ) {
            console.log("mobile====", m);
            m.result.setAsyncError({
              key: "norepeat",
              message: `${m.displayName}${
                m.moduleId == 2 || m.moduleId == 3 ? "已报名" : "已存在"
              }`,
              validator: () => {
                return new Promise((resolve) => {
                  if (this.isSubmitting) {
                    resolve(true);
                    return;
                  }
                  service
                    .checkRepeatable({
                      customFormId: sbaseData.customFormId,
                      fieldId: m.fieldName,
                      fieldValue: m.result.value,
                      ver: "v2.0.1",
                      globalUserId: ck.cookie("globalUserId"),
                      tenantId: this.tenantId,
                    })
                    .subscribe((result) => {
                      console.log("result===", result);
                      resolve(result.content.result);
                    });
                });
              },
            });
          }
        });
      });
    },
    commonWebinar() {
      if (this.formInfo.moduleType == "2" && this.formInfo.videoType == "1") {
        this.getWebinarInfo();
      }
    },
    statusToView() {
      // 从哪里进入表单
      this.entryPoint();
      // 0 未开始 2 已结束
      if (!sbaseData.preview) {
        service.getServerTime({}).subscribe((data) => {
          if (data.result == 0) {
            const currentTime = Number(data.content);
            this.formInfo.status = 1;
            if (
              this.formInfo.startTime &&
              currentTime < this.formInfo.startTime
            ) {
              this.formInfo.status = 0;
            }
            if (this.formInfo.endTime && currentTime > this.formInfo.endTime) {
              this.formInfo.status = 2;
            }

            window.$sk.loading.hide();
          } else {
            window.$sk.alert(data.desc);
          }
        });
      } else {
        window.$sk.loading.hide();
      }
      const formInfo = this.formInfo;
      const userStatusInfo = this.user.status;
      if (formInfo.moduleType == 2 || formInfo.moduleType == 3) {
        if (userStatusInfo.signupStatus === "successfully") {
          if (formInfo.moduleType == 2 && this.whereform == "webinar") {
            this.getLink("successfully");
            return;
          } else {
            this.jumpLink();
          }
        } else if (userStatusInfo.signupStatus === "allow") {
          if (this.isTrackClosed) {
            this.isTrackClosedMessage = true;
            window.$sk.loading.hide();
          }
          //允许报名 而且是线下会 并且是全部用户参与而且没有报过名表单开始了那么跳转到verify 页面 （身份验证页面）
          if (
            formInfo.moduleType == "3" &&
            formInfo.attendWay == 1 &&
            formInfo.status == 1 &&
            userStatusInfo.formData.length == 0 &&
            sbaseData.urlForm != "verify" &&
            formInfo.isAuthentication == "1"
          ) {
            this.$router.push({
              path: `${this.platform}_verify`,
              query: this.d.router,
            });
            return;
          }

          // 浏览表单记录互动行为
          this.interactiveBrowse();
          // 初始化微信分享
          if (agentType() == "weChat") {
            this.initWeChatShare();
          } else if (agentType() == "wxWork") {
            initJsSdk(this.tenantId, () => {
              this.initWxWorkShare();
            });
          }
          //initWeChatShare(vm.formInfo, member, vm.wx.openId);
        } else if (
          userStatusInfo.signupStatus === "notallow" &&
          formInfo.moduleType == 2
        ) {
          // instanceDesc返回会议状态 //状态 0-失败, 1-待发布, 2-审核中, 3-已发布, 4-已结束, 99-垃圾箱
          // 1 proposed ；2 ready ；3 launched；4 completed ；99 canceled
          if (this.whereform == "webinar") {
            //线上会来的直接不允许报名
            if (userStatusInfo.instanceDesc == "completed") {
              this.getLink("completed");
            } else {
              this.getLink("notallow");
            }
          } else {
            // 工单，表单开启审核后，第二次扫码报错。returnUrl undefine 沟通后修改为直接跳转
            if (sbaseData.returnUrl) {
              window.$sk.goto(sbaseData.returnUrl);
            } else if (
              formInfo.completeActionType == "2" &&
              !!formInfo.completeAction
            ) {
              window.$sk.goto(formInfo.completeAction);
            } else {
              this.$router.push({
                path: `${this.platform}_success`,
                query: this.d.router,
              });
            }
          }
        } else if (
          userStatusInfo.signupStatus === "notallow" &&
          formInfo.moduleType == 3
        ) {
          this.$router.push({
            path: `${this.platform}_success`,
            query: this.d.router,
          });
        } else if (
          userStatusInfo.signupStatus === "pending" &&
          formInfo.moduleType == 2 &&
          this.whereform == "webinar"
        ) {
          this.getLink("pending");
        } else {
          //verifyButtonShow(vm.formInfo);
        }
      } else {
        //需要检查是否参与过
        if (formInfo.attendWay == 4) {
          // 不知道干啥的
          //if (bindData.content.enteredId) {
          //  vm.enteredId = bindData.content.enteredId;
          //}
          if (
            userStatusInfo.signupStatus === "successfully" &&
            userStatusInfo.formData.length
          ) {
            //userStatusInfo.formData.forEach((data) => {
            //  this.formData.forEach((field) => {
            //    console.log('field===',data,field)
            //    if (data.fieldName === field.fieldName) {
            //      //field.value = data.value;
            //      /**
            //       * 保存敏感字段回显值
            //       */
            //      //field.setSensitiveValue(data.value);
            //      return false;
            //    }
            //  });
            //});
            console.log("this.formData", this.formData);
          }

          // 浏览表单记录互动行为
          this.interactiveBrowse();
          // 初始化微信分享
          if (agentType() == "weChat") {
            this.initWeChatShare();
          } else if (agentType() == "wxWork") {
            initJsSdk(this.tenantId, () => {
              this.initWxWorkShare();
            });
          }
          //initWeChatShare(vm.formInfo, member, vm.wx.openId);
        } else {
          // 浏览表单记录互动行为
          this.interactiveBrowse();
          // 初始化微信分享
          if (agentType() == "weChat") {
            this.initWeChatShare();
          } else if (agentType() == "wxWork") {
            initJsSdk(this.tenantId, () => {
              this.initWxWorkShare();
            });
          }
          //initWeChatShare(vm.formInfo, member, vm.wx.openId);
        }
      }
    },
    interactiveView() {
      if (!sbaseData.preview) {
        service.view({
          customFormId: sbaseData.customFormId,
          linkId: sbaseData.linkId,
          trackingCode: sbaseData.tc,
          globalUserId: ck.cookie("globalUserId"),
          openId: this.user.openId,
          memberId: this.member.memberId,
          url: location.href,
          referenceUrl: document.referrer,
          weChatId: this.user.weChatId,
          sess: this.member.session,
        });
      }
    },
    interactiveBrowse() {
      service.browse({
        openId:
          this.user.openId ||
          ck.cookie("openId" + this.formInfo.attachWXAccount) ||
          "",
        sess: this.member.session || "",
        globalUserId: ck.cookie("globalUserId"),
        tenantId: this.formInfo.tenantId,
        customFormId: sbaseData.customFormId,
        markCode: sbaseData.markCode,
        marketingSess: ck.cookie("marketingSess"),
      });
    },
    entryPoint() {
      //判断从哪里来 分线上会 和 其他  线上会实例下问卷等互动进入 其他  //后端需要加一个参数 isWebinar
      if (this.formInfo.moduleType == "2" && this.formInfo.videoType == "1") {
        if (sbaseData.returnUrl) {
          if (sbaseData.returnUrl.indexOf("webinarId") > -1) {
            this.whereform = "webinar";
          } else {
            // 线上会是互动过来的 比如问卷
            this.whereform = "otherback";
          }
        } else {
          //线上会直接打开报名表单
          this.whereform = "webinar";
        }
      } else {
        this.whereform = "other";
      }
    },

    ///线上会特有逻辑
    getWebinarInfo() {
      const webinarId = this.formInfo.objectId;
      const getServerTime = new Promise((resolve) => {
        service.getServerTime({ webinarId: webinarId }).subscribe((data) => {
          if (data.result == 0) {
            this.serverTime = data.content.time;
            resolve();
          } else {
            window.$sk.alert(data.desc);
          }
        });
      });
      const getWebinar = new Promise((resolve) => {
        const info = {
          instanceId: sbaseData.instanceId,
          webinarId: webinarId,
          tenantId: this.tenantId,
        };
        service.getWebinar(info).subscribe(
          (data) => {
            this.mettInfo = data.content.webinarInfo;
            resolve();
          },
          (err) => {
            console.log("获取会议信息失败", err);
          }
        );
      });
      Promise.all([getServerTime, getWebinar]).then(() => {
        this.getWenbinarState();
      });
    },

    ///线上会特有逻辑
    getWenbinarState() {
      const serverTime = this.serverTime;
      const mettInfo = this.mettInfo;
      if (
        serverTime * 1000 <
        mettInfo.startTime * 1000 - mettInfo.startTimeOffset * 60 * 1000
      ) {
        //会议未开始
        this.webinarState = "noStart";
      } else if (
        serverTime * 1000 >
        mettInfo.endTime * 1000 + mettInfo.endTimeOffset * 60 * 1000
      ) {
        //会议已经结束
        if (mettInfo.replaySwitch === 1) {
          this.webinarState = "open";
        } else {
          this.webinarState = "end";
        }
      } else {
        //会议进行中
        this.webinarState = "open";
      }
    },

    formIsValid() {
      let count = 0;
      let verifyFail = false;
      this.formData.map((field) => {
        const val = field.value;
        if (!val && field.isShow) {
          return;
        }
        if (cr.isArray(val)) {
          if (val.length > 0) {
            count++;
          }
        } else if (typeof val === "string") {
          if (val) {
            count++;
          }
        } else if ("fieldName" in val) {
          if (val.value && (val.value.length || val.value.mapId)) {
            count++;
          }
          if (
            val.fieldName === "mobile" &&
            parseInt(field.required, 10) === 1 &&
            parseInt(field.isSendSms, 10) === 1 &&
            !val.checkCode &&
            field.isShow
          ) {
            val.VerifyFail = true;
          }
        }
        if (val.VerifyFail && field.isShow) {
          verifyFail = true;
        }
      });

      // 定位到错误位置
      let anchor = this.$el.querySelector(".err");
      if (anchor) {
        document.documentElement.scrollTop = anchor.offsetTop - 20;
        document.body.scrollTop = anchor.offsetTop - 20;
      }

      if (count === 0) {
        window.$sk.alert("请填写表单内容后提交");
        return false;
      } else if (verifyFail) {
        return false;
      }
      return true;
    },
    // 已报名 去会场
    togoVerify() {
      if (sbaseData.isSetting) {
        return;
      }
      this.$router.push({
        path: `${this.platform}_verify`,
        query: this.d.router,
      });
    },
    submit() {
      if (sbaseData.isSetting) {
        return;
      }
      this.formData = this.formData.filter((m) => {
        m.checkFlag = !m.checkFlag; //触发校验
        return true;
      });

      this.$nextTick(() => {
        console.log("submit this.formData)===", this.formData);

        if (this.formIsValid()) {
          this.isSubmitting = true;
          let submitData = {
            tenantId: this.tenantId,
            sess: this.member.session,
            customFormId: sbaseData.customFormId,
            linkId: sbaseData.linkId,
            instanceId: this.formInfo.instanceId,
            globalUserId: this.user.globalUserId,
            url: window.location.href,
            referenceUrl: interact.isWeChat ? "微信" : document.referrer,
            preview: sbaseData.preview,
            tc: sbaseData.tc,
            markCode: sbaseData.markCode,
            markType: sbaseData.markType,
            marketingSess: ck.cookie("marketingSess"),
            items: [],
            openId: "",
            ver: "v2.0.1", // 不加接口报错
          };
          if (this.rulesJump == 2) {
            submitData = { rulesJump: this.rulesJump, ...submitData };
          }
          if (this.user.weChatId && this.user.openId) {
            submitData.isBind = true;
            submitData.weChatId = this.user.weChatId;
            submitData.openId = this.user.openId;
          } else if (
            interact.isWeChat &&
            (sbaseData.weChatId || sbaseData.returnUrl)
          ) {
            let weChatId = sbaseData.weChatId;
            if (!weChatId) {
              const url = sbaseData.returnUrl;
              const re = new RegExp(
                "(^|&)" + "weChatId" + "=([^&]*)(&|$)",
                "i"
              );
              const Parameter = url.match(re);
              if (Parameter !== null) {
                weChatId = Parameter[2];
              }
            }

            const wechatInfo = ck.cookie("verifyInfo_" + weChatId);
            if (wechatInfo && wechatInfo.original) {
              submitData.isBind = true;
              submitData.weChatId = weChatId;
              submitData.openId =
                wechatInfo.original.openid || wechatInfo.original.openId;
            }
          }

          if (this.formInfo.enableWxFollow == 1 && !submitData.openId) {
            submitData.openId = window.$sk.template.get()
              ? window.$sk.template.get().user.subscribeOpenId
              : "";
          }

          //let formData = Object.assign([], this.formData);
          this.formData.forEach((d) => {
            if (d.value && d.isShow) {
              submitData.items.push(d.value);
              if (
                d.value.fieldName === "mobile" &&
                parseInt(d.isSendSms) === 1
              ) {
                submitData.verificationCode = d.value.checkCode;
              }
            }
          });

          //this.beforeRegisterHandler(submitData);

          console.log("submit formData--", submitData, this.$refs);
          service.submitCustomform(submitData).subscribe((data) => {
            this.afterRegisterHandler(data);
            setTimeout(() => {
              this.isSubmitting = false;
            }, 500);
          });
        } else {
          //this.validationErrorHandler(errFields);
          this.isSubmitting = false;
        }
      });
    },

    afterRegisterHandler(data) {
      if (data.result != 0) {
        if (data.result == "100040") {
          window.$sk.confirm(data.desc, {
            okValue: "下一步",
            ok: () => {
              this.jumpLink();
            },
          });
        } else {
          window.$sk.alert(data.desc);
        }
      } else {
        //判断作为报名，是否报名成功
        if (data.content == 0 || data.content.status === "successfully") {
          //存在签到点字段返回信息
          if (data.content.signpointDesc) {
            window.$sk.alert("报名成功！\r\n" + data.content.signpointDesc);
          }
          //如果是线上会 答完以后跳转线上会逻辑的url  结束动作优先
          if (this.formInfo.moduleType == "2" && this.whereform === "webinar") {
            if (this.formInfo.auditingType == "1") {
              this.getLink("pending");
            } else {
              this.getLink("successfully");
            }
          } else {
            this.jumpLink();
          }
        } else {
          window.$sk.alert(data.content.statusDesc);
          //vm.submitText('提交');
        }
      }
    },
    jumpLink() {
      if (this.formInfo.completeActionType == "1") {
        //手机端并且是选的抽奖 跳转抽奖
        const luckyDrawId =
          this.formInfo.completeAction || this.formInfo.luckyDrawId;
        service
          .getLuckydraw({
            luckyDrawId: luckyDrawId,
            tenantId: this.tenantId,
            hasVirtualAward: false,
          })
          .subscribe((data) => {
            let mobileObj = data["content"]["template"]["mobile"];
            let schemaId = data["content"]["schemaId"];
            let weChatId = data["content"]["weChatId"];
            let tenantId = data["content"]["tenantId"];
            let source = interact.isMobile ? "wap" : "pc";
            if (sbaseData.returnUrl) {
              window.$sk.goto(sbaseData.returnUrl);
            } else {
              if (weChatId) {
                window.$sk.goto(
                  mobileObj["formalUrl"] +
                    "?configId=" +
                    mobileObj["configId"] +
                    "&tenantId=" +
                    tenantId +
                    "&schemaId=" +
                    schemaId +
                    "&type=7" +
                    "&objId=" +
                    customFormId +
                    "&weChatId=" +
                    weChatId +
                    "&source=" +
                    source
                );
              } else {
                window.$sk.goto(
                  mobileObj["formalUrl"] +
                    "?configId=" +
                    mobileObj["configId"] +
                    "&tenantId=" +
                    tenantId +
                    "&schemaId=" +
                    schemaId +
                    "&type=7" +
                    "&objId=" +
                    customFormId +
                    "&source=" +
                    source
                );
              }
            }
          });
      } else {
        if (
          sbaseData.returnUrl ||
          (this.formInfo.completeActionType == "2" &&
            !!this.formInfo.completeAction)
        ) {
          if (sbaseData.returnUrl) {
            window.$sk.goto(sbaseData.returnUrl);
          } else {
            window.$sk.goto(this.formInfo.completeAction);
          }
        } else {
          this.$router.push({
            path: `${this.platform}_success`,
            query: this.d.router,
          });
        }
      }
    },

    getLink(personState) {
      switch (personState) {
        case "successfully":
          window.$sk.tips.show("通过！", {
            time: 2000,
            callback: () => {
              const returnUrl = sbaseData.returnUrl;
              if (returnUrl && returnUrl.indexOf("meetingInfo") == -1) {
                window.$sk.goto(returnUrl);
              } else {
                if (this.webinarState == "open") {
                  this.goToWebinarLink("meeting");
                } else {
                  this.goToWebinarLink("meetingInfo");
                }
              }
            },
          });
          break;
        case "pending":
          window.$sk.tips.show("您的报名信息正在审核，请等待！", {
            time: 3000,
            callback: () => {
              this.goToWebinarLink("meetingInfo");
            },
          });
          break;
        case "notallow":
          window.$sk.tips.show("很抱歉！您未通过报名审核！", {
            time: 3000,
            callback: () => {
              this.goToWebinarLink("meetingInfo");
            },
          });
          break;
        case "completed":
          window.$sk.tips.show("很抱歉！会议已结束，您来晚了！", {
            time: 3000,
            callback: () => {
              this.goToWebinarLink("meetingInfo");
            },
          });
          break;
      }
    },
    goToWebinarLink(type) {
      let returnUrl = window.$sk.replaceDomain(sbaseData.returnUrl);
      const mettInfo = this.mettInfo;
      const links = {
        wap_meetingInfo:
          returnUrl && returnUrl.includes("meetingInfo")
            ? returnUrl
            : mettInfo.wapUrl,
        wap_meeting:
          returnUrl && returnUrl.includes("meetingInfo")
            ? returnUrl.replace("meetingInfo", "meeting")
            : mettInfo.liveWapUrl,
        pc_meetingInfo:
          returnUrl && returnUrl.includes("meetingInfo")
            ? returnUrl
            : mettInfo.pcUrl,
        pc_meeting:
          returnUrl && returnUrl.includes("meetingInfo")
            ? returnUrl.replace("meetingInfo", "meeting")
            : mettInfo.livePcUrl,
      };

      if (this.webinarState == "open") {
        //进行中
        if (interact.isMobile) {
          window.$sk.goto(links[`wap_${type}`]);
        } else {
          window.$sk.goto(links[`pc_${type}`]);
        }
      } else {
        if (interact.isMobile) {
          if (mettInfo.signupEndWapUrl) {
            window.$sk.goto(mettInfo.signupEndWapUrl);
          } else {
            window.$sk.goto(links[`wap_${type}`]);
          }
        } else {
          if (mettInfo.signupEndPcUrl) {
            window.$sk.goto(mettInfo.signupEndPcUrl);
          } else {
            window.$sk.goto(links[`pc_${type}`]);
          }
        }
      }
    },

    initWxWorkShare() {
      const url = URLS.removeSearchParam(
        window.location.href,
        "token",
        "retCode",
        "puzzleFlag"
      );
      const info = this.formInfo;
      const shareInfo = {
        title: info.shareTitle || info.title, // 分享标题,
        desc: info.shareDesc || "", // 分享描述,
        link:
          URL.weworkCustomerJumpUrl.replace("{$tenantId}", this.tenantId) +
          encodeURIComponent(url), //这里需要改
        imgUrl: info.shareImageRealPath
          ? "https:" + info.shareImageRealPath
          : "", // 分享图标
      };
      shareInfo.link = window.$swxsdk.urlAddChannel(shareInfo.link);
      window.wx.onMenuShareAppMessage({ ...shareInfo });
      window.wx.onMenuShareWechat({ ...shareInfo });
      window.wx.onMenuShareTimeline({ ...shareInfo });
    },
    initWeChatShare() {
      if (!interact.isWeChat) {
        return;
      }
      const formInfo = this.formInfo;
      const shareInfo = {
        title: formInfo.shareTitle || formInfo.title, // 分享标题,
        desc: formInfo.shareDesc || "", // 分享描述,
        link: sbaseData.weChatId
          ? window.config.weChatOauthUrl +
            "?weChatId=" +
            sbaseData.weChatId +
            "&scope=&return_url=" +
            encodeURIComponent(
              URLS.removeSearchParam(
                window.location.href,
                "token",
                "retCode",
                "puzzleFlag"
              )
            )
          : window.location.href,
        imgUrl: formInfo.shareImageRealPath
          ? "https:" + formInfo.shareImageRealPath
          : "", // 分享图标
      };
      window.$swxsdk.initWxSdk(
        {
          tenantId: formInfo.tenantId,
          weChatId: formInfo.attachWXAccount || sbaseData.weChatId,
        },
        window.apiUrl
      );
      window.$swxsdk.on("sharer", shareInfo);
      window.$swxsdk.on("sharer_friends", shareInfo);
      if (formInfo.enableShare == 0) {
        window.$swxsdk.on("hideAllNonBaseMenuItem");
      } else {
        window.$swxsdk.on("showAllNonBaseMenuItem");
      }
    },
    setTitle(formInfo) {
      if (this.$route.path === "/" || this.$route.path.includes("_index")) {
        if (sbaseData.preview) {
          document.title = `预览${this.platform}_${formInfo["title"]}_表单管理_Smarket智营`;
          if (formInfo.instanceId) {
            service
              .getChannel({
                id: formInfo.instanceId,
              })
              .subscribe((data) => {
                document.title = `预览${this.platform}_${
                  formInfo.title
                }_表单管理_${data.content.name}_${
                  {
                    1: "微信",
                    2: "线上会议",
                    3: "线下会议",
                  }[data.content.moduleType]
                }_Smarket智营`;
              });
          }
        } else if (formInfo.moduleType == "2" || formInfo.moduleType == "3") {
          //不是预览，并且是线上会/线下会表单 使用会议标题为title
          //获取会议信息，设置会议title
          service
            .getChannel({
              id: formInfo.instanceId,
            })
            .subscribe((data) => {
              if (data.content) {
                document.title = data.content.name;
              }
            });
        } else {
          document.title = formInfo.title;
        }
      } else {
        document.title = "身份验证";
      }
    },
  },
};
